function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { mix, extractContentType, isLikelyJsonMime } from "./utils.js";
import { JSON_MIME, CONTENT_TYPE_HEADER, CATCHER_FALLBACK } from "./constants.js";
import { resolver } from "./resolver.js";
import config from "./config.js";
export var core = {
  _url: "",
  _options: {},
  _config: config,
  _catchers: new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon: function addon(_addon) {
    return _objectSpread(_objectSpread({}, this), {}, {
      _addons: [].concat(_toConsumableArray(this._addons), [_addon])
    }, _addon.wretch);
  },
  errorType: function errorType(_errorType) {
    return _objectSpread(_objectSpread({}, this), {}, {
      _config: _objectSpread(_objectSpread({}, this._config), {}, {
        errorType: _errorType
      })
    });
  },
  polyfills: function polyfills(_polyfills) {
    var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _objectSpread(_objectSpread({}, this), {}, {
      _config: _objectSpread(_objectSpread({}, this._config), {}, {
        polyfills: replace ? _polyfills : mix(this._config.polyfills, _polyfills)
      })
    });
  },
  url: function url(_url) {
    var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (replace) return _objectSpread(_objectSpread({}, this), {}, {
      _url: _url
    });
    var split = this._url.split("?");
    return _objectSpread(_objectSpread({}, this), {}, {
      _url: split.length > 1 ? split[0] + _url + "?" + split[1] : this._url + _url
    });
  },
  options: function options(_options) {
    var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _objectSpread(_objectSpread({}, this), {}, {
      _options: replace ? _options : mix(this._options, _options)
    });
  },
  headers: function headers(headerValues) {
    return _objectSpread(_objectSpread({}, this), {}, {
      _options: mix(this._options, {
        headers: headerValues || {}
      })
    });
  },
  accept: function accept(headerValue) {
    return this.headers({
      Accept: headerValue
    });
  },
  content: function content(headerValue) {
    return this.headers(_defineProperty({}, CONTENT_TYPE_HEADER, headerValue));
  },
  auth: function auth(headerValue) {
    return this.headers({
      Authorization: headerValue
    });
  },
  catcher: function catcher(errorId, _catcher) {
    var newMap = new Map(this._catchers);
    newMap.set(errorId, _catcher);
    return _objectSpread(_objectSpread({}, this), {}, {
      _catchers: newMap
    });
  },
  catcherFallback: function catcherFallback(catcher) {
    return this.catcher(CATCHER_FALLBACK, catcher);
  },
  resolve: function resolve(resolver) {
    var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _objectSpread(_objectSpread({}, this), {}, {
      _resolvers: clear ? [resolver] : [].concat(_toConsumableArray(this._resolvers), [resolver])
    });
  },
  defer: function defer(callback) {
    var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _objectSpread(_objectSpread({}, this), {}, {
      _deferred: clear ? [callback] : [].concat(_toConsumableArray(this._deferred), [callback])
    });
  },
  middlewares: function middlewares(_middlewares) {
    var clear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return _objectSpread(_objectSpread({}, this), {}, {
      _middlewares: clear ? _middlewares : [].concat(_toConsumableArray(this._middlewares), _toConsumableArray(_middlewares))
    });
  },
  fetch: function fetch() {
    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._options.method;
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var base = this.url(url).options({
      method: method
    });
    // "Jsonify" the body if it is an object and if it is likely that the content type targets json.
    var contentType = extractContentType(base._options.headers);
    var jsonify = _typeof(body) === "object" && (!base._options.headers || !contentType || isLikelyJsonMime(contentType));
    base = !body ? base : jsonify ? base.json(body, contentType) : base.body(body);
    return resolver(base._deferred.reduce(function (acc, curr) {
      return curr(acc, acc._url, acc._options);
    }, base));
  },
  get: function get() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return this.fetch("GET", url);
  },
  "delete": function _delete() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return this.fetch("DELETE", url);
  },
  put: function put(body) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return this.fetch("PUT", url, body);
  },
  post: function post(body) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return this.fetch("POST", url, body);
  },
  patch: function patch(body) {
    var url = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    return this.fetch("PATCH", url, body);
  },
  head: function head() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return this.fetch("HEAD", url);
  },
  opts: function opts() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    return this.fetch("OPTIONS", url);
  },
  body: function body(contents) {
    return _objectSpread(_objectSpread({}, this), {}, {
      _options: _objectSpread(_objectSpread({}, this._options), {}, {
        body: contents
      })
    });
  },
  json: function json(jsObject, contentType) {
    var currentContentType = extractContentType(this._options.headers);
    return this.content(contentType || isLikelyJsonMime(currentContentType) && currentContentType || JSON_MIME).body(JSON.stringify(jsObject));
  }
};